import React from 'react';

import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import { getValueWithEllipsis } from '@/src/util/strings';

const DEFAULT_MAX_LENGTH = 16;

type LongTextProps = {
  value?: string;
  tooltipId?: string;
  tooltipClassName?: string;
  maxLength: number;
};

const LongText = ({
  value,
  tooltipId,
  tooltipClassName = '',
  maxLength = DEFAULT_MAX_LENGTH,
}: LongTextProps) => {
  // const { value, tooltipId, tooltipClassName = '', maxLength = DEFAULT_MAX_LENGTH } = this.props;

  return (
    <React.Fragment>
      <span data-tooltip-id={`${tooltipId}`}>{getValueWithEllipsis(value, maxLength)}</span>
      {value.length > maxLength && (
        <Tooltip className={tooltipClassName} id={tooltipId} place="bottom" effect="solid">
          {value}
        </Tooltip>
      )}
    </React.Fragment>
  );
};

LongText.defaultProps = {
  maxLength: DEFAULT_MAX_LENGTH,
};

export default LongText;
